/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Ontmoet nieuwe mensen, chat, socialize",
      "Onjuist telefoonnummer",
      "Get the app",
      "Verder met Apple",
      "Verder met Facebook",
      "Verder met Google",
      "Inloggen",
      "Registreren",
      "Vul de tekens die je ziet in om verder te gaan.",
      "Verder",
      "Vul de tekens in:",
      "Veiligheids­check",
      "Verversen",
      "Kies een wachtwoord dat je kunt onthouden:",
      "Opslaan",
      "Bevestig je wachtwoord",
      "Wachtwoord moet minstens {{num}} [[characters:num]] bevatten",
      "Wachtwoord",
      "Nieuw wachtwoord",
      "Badoo – Blog",
      "Vacatures",
      "Chatten",
      "Steden",
      "Cookies beheren",
      "Copyright © 2006 – heden. Bumble. Alle rechten voorbehouden.",
      "Apple en het Apple-logo zijn handelsmerken van Apple Inc.{{__EOL__}}Google Play is een handelsmerk van Google LLC.",
      "Downloaden",
      "Facebook",
      "Volg ons",
      "Hulppagina",
      "Instagram",
      "Taal",
      "LinkedIn",
      "Overzicht",
      "Badoo is onderdeel van Bumble Inc.",
      "Privacybeleid",
      "Safety centre",
      "Sitemap",
      "Verklaring inzake moderne slavernij",
      "Algemene voorwaarden",
      "Twitter",
      "Vul je e-mailadres of mobiele nummer in en wij sturen je instructies om een nieuw wachtwoord aan te maken.",
      "Nieuw wachtwoord aanvragen",
      "Vul je e‑mailadres of mobiele nummer in",
      "Wachtwoord vergeten",
      "Foto's van modellen zijn uitsluitend ter illustratie",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Wachten op een match is niet nodig.{{__EOL__}}{{__EOL__}}Chat meteen over de dingen die ertoe doen. Zo leer jullie elkaar echt kennen.",
      "Zin om meteen te chatten?",
      "Door je te registreren, ga je akkoord met onze <a class=\"link\" href=\"{{terms_url}}\">Algemene voorwaarden</a>. Hoe we omgaan met je gegevens lees je in ons <a class=\"link\" href=\"{{privacy_url}}\">Privacybeleid</a>.",
      "Wij helpen je meer van jouw persoonlijkheid te tonen, <br />zodat daten goed voelt.",
      "Dit is daten met vertrouwen.",
      "of",
      "Heb je al een profiel?",
      "Registreren met e-mail of telefoonnummer",
      "Voor jouw verwachtingen en verlangens{{__EOL__}}hoef je je nooit te verontschuldigen.",
      "Wil je alleen chatten? Geen probleem.{{__EOL__}}Klaar voor een relatie? Ook perfect.{{__EOL__}}{{__EOL__}}Intenties kun je altijd aanpassen.",
      "Hier om te daten",
      "Toe aan een relatie",
      "Hier om te chatten",
      "Ontmoet mensen die hetzelfde zoeken als jij.",
      "{{name}}, {{age}}",
      "Wat je ook doet, zorg dat jouw veiligheid op de eerste plaats komt.",
      "In ons Safety centre vind je informatie, tips en advies om vol vertrouwen te daten.",
      "Bezoek ons Safety centre",
      "Jouw veiligheid is<br/>onze topprioriteit.",
      "Vanaf het eerste moment had ik het gevoel dat het zou werken...",
      "Eerst was ik niet op zoek naar vastigheid ...",
      "Als ik anderen op Badoo één tip mocht geven, zou ik zeggen: wees jezelf...",
      "Verhalen over succes op Badoo",
      "Meer succesverhalen bekijken",
      "Beoordeling:__CUT__{{num}}",
      "Apple App Store",
      "Vertrouw op ons. Sinds 2006 hebben we al miljoenen mensen gematcht.",
      "{{num}} mln__CUT__downloads",
      "{{num}}.000",
      "Google Play Store",
      "We weten wat we doen.",
      "Log in met je e‑mailadres of mobiele nummer",
      "Vul je wachtwoord in",
      "Wachtwoord vergeten?",
      "Registreren",
      "Heb je nog geen profiel?",
      "Inloggen",
      "Registreren"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "tekens"
            ],
            "singular": [
                  "teken"
            ]
      },
      "day": {
            "plural": [
                  "dagen"
            ],
            "singular": [
                  "dag"
            ]
      },
      "hour": {
            "plural": [
                  "uur"
            ],
            "singular": [
                  "uur"
            ]
      },
      "minute": {
            "plural": [
                  "minuten"
            ],
            "singular": [
                  "minuut"
            ]
      },
      "month": {
            "plural": [
                  "maanden"
            ],
            "singular": [
                  "maand"
            ]
      },
      "second": {
            "plural": [
                  "seconden"
            ],
            "singular": [
                  "seconde"
            ]
      },
      "year": {
            "plural": [
                  "jaar"
            ],
            "singular": [
                  "jaar"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
